// Navigation Items

import OVERVIEW from "app/navigations/groups/overview";
import INVENTORY from "app/navigations/groups/inventory";
import ORDERS from "app/navigations/groups/orders";
import USERS from "app/navigations/groups/users";
import ADMIN from "app/navigations/groups/admin";

const NAVIGATION_ITEMS = { ...OVERVIEW, ...INVENTORY, ...ORDERS, ...USERS, ...ADMIN };

export default NAVIGATION_ITEMS;
